import BaseAdapter from '@linc-technologies/linced-common/adapters/base';

export default class Policy extends BaseAdapter {
  namespace = 'people/v4';
  modelNamePlural = 'policies';
}
